if ($('#users_table').length) {

    let url = window.location.origin + '/users/get';

    setTimeout(function () {
        users_table();
    }, 500);

    function users_table() {
        $('#users_table').dataTable({
            "processing": true,
            "serverSide": true,
            "ajax": url,
            "columns": [
                {data: 'name'},
                {data: 'email'},
                {data: 'rol'},
                {data: 'status'},
            ],
            "order": [[3, 'asc']],
            "columnDefs": [
                {
                    "targets": 3,
                    "render": function (data, type, row, meta) {
                        if (row.status === Status.ACTIVO) {
                            return "<span class='badge badge-success'><big>Activo</big></span>";
                        } else {
                            return "<span class='badge badge-danger'><big>Desactivado</big></span>";
                        }
                    }
                },
                {
                    "targets": 4,
                    "render": function (data, type, row, meta) {

                        //if (row.id === 1) return "No Aplica";

                        if (row.status === 'A') {
                            return "<button type='button' class='btn btn-primary btn-sm edit-users' data-user='" + row + "' data-bs-toggle='tooltip' title='Editar Usuario'><i class='fas fa-pencil-alt'></i></button> "
                                + "<button type='button' class='btn btn-info btn-sm permissions' data-user='" + row + "' data-bs-toggle='tooltip' title='Asignar Permisos'><i class='fa fa-key' aria-hidden='true'></i></button> "
                                + "<button type='button' class='btn btn-danger btn-sm remove-users' data-user='" + row + "' data-bs-toggle='tooltip' title='Desactivar Usuario'><i class='fas fa-trash'></i></button> ";
                        } else {
                            return "<button type='button' class='btn btn-primary btn-sm activate-users' data-user='" + row + "' data-bs-toggle='tooltip' title='Activar Usuario'><i class='fa fa-check'></i></button> "
                                + "<button type='button' class='btn btn-info btn-sm permissions' data-user='" + row + "' ><i class='fa fa-key' aria-hidden='true' data-bs-toggle='tooltip' title='Asignar Permisos'></i></button> ";
                        }
                    }
                }],
            "language": {
                "url": window.location.origin + "/json/Spanish.json"
            },
        });

        $('#users_table').on('draw.dt', function () {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });

        $('#users_table tbody').on('click', '.edit-users', function (e) {
            e.preventDefault();
            let table = $("#users_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/users/' + rowData.id + '/edit',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_users').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    /*$('.dropify').dropify({
                        messages: {
                            'default': 'Arrastre y suelte un archivo o haga clic',
                            'replace': 'Arrastra y suelta o haz clic para reemplazar',
                            'remove': 'Eliminar',
                            'error': 'Vaya, sucedió algo mal'
                        }
                    });*/
                    $('#modal-users').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });


        $('#users_table tbody').on('click', '.permissions', function (e) {
            e.preventDefault();
            let table = $("#users_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            $.ajax({
                url: window.location.origin + '/permissions/users/' + rowData.id + '/roles/',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_users').innerHTML = response;
                    $('.chosen-select').chosen({width: '100%'});
                    $('#modal-usersEntityHasRoles').modal("show");

                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        });



        $('#users_table tbody').on('click', '.remove-users', function (e) {
            e.preventDefault();
            let table = $("#users_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();
            Swal
                .fire({
                    title: "Eliminar al usuario " + rowData.name,
                    text: "¿Eliminar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        let url = window.location.origin + '/users/' + rowData.id;
                        $.ajax({
                            url: url,
                            type: 'DELETE',
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Eliminado', ' Se ha desactivado el usuario.', 'success')
                                    .then(() => {
                                        let url = window.location.origin + '/users/get';
                                        $('#users_table').DataTable().ajax.url(url).load();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });

        $('#users_table tbody').on('click', '.activate-users', function (e) {
            e.preventDefault();
            let table = $("#users_table").DataTable();
            let rowData = table.row($(this).parents('tr')).data();

            Swal
                .fire({
                    title: "Reactivar al usuario " + rowData.name,
                    text: "¿Activar?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: "Sí, activarlo",
                    cancelButtonText: "Cancelar",
                })
                .then(resultado => {
                    if (resultado.value) {
                        $.ajax({
                            url: window.location.origin + '/users/reactivate',
                            type: 'POST',
                            data: {
                                id: rowData.id
                            },
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        })
                            .done(function (response) {
                                Swal.fire('Activado', 'Se ha reactivado el usuario.', 'success')
                                    .then(() => {
                                        let url = window.location.origin + '/users/get';
                                        $('#users_table').DataTable().ajax.url(url).load();
                                    });
                            })
                            .fail(function (jqXHR, textStatus) {
                                console.log(jqXHR);
                                alert("Disculpe, existió un problema");
                            });
                    }
                });
        });
    }

    $(".add_users").on('click', function () {

        $.ajax({
            url: window.location.origin + '/users/create',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_modal_users').innerHTML = response;
                $('.chosen-select').chosen({width: '100%'});
                $('#modal-users').modal("show");

            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });

    })

    $(document).on('click', '#send_users', function (event) {
        event.preventDefault();

        let url = window.location.origin + '/users';
        let formData = new FormData();

        formData.append('name', $("#nombre").val());
        formData.append('email', $("#correo").val());
        formData.append('phone', $("#phone").val());
        formData.append('routes_id', $("#routes_id").val());
        formData.append('pass', $("#pass").val());
        formData.append('pass2', $("#pass2").val());
        formData.append('rol', $("#rol").val());
        formData.append('area_surtido_code', $(".area_surtido_code").val());

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                Swal.fire('Agregado', ' Se agrego el usuario correctamente', 'success')
                    .then(() => {
                        $('#modal-users').modal("hide");
                        let url = window.location.origin + '/users/get';
                        $('#users_table').DataTable().ajax.url(url).load();
                    });
            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

    $(document).on('click', '#sent_users_update', function (event) {

        event.preventDefault();

        let id = $("#id").val();
        let url = window.location.origin + '/users/' + id;
        let formData = new FormData();

        formData.append('id', $("#id").val());
        formData.append('name', $("#nombre").val());
        formData.append('email', $("#correo").val());
        formData.append('phone', $("#phone").val());
        formData.append('routes_id', $("#routes_id").val());
        formData.append('pass', $("#pass").val());
        formData.append('pass2', $("#pass2").val());
        formData.append('rol', $("#rol").val());
        formData.append('area_surtido_code', $(".area_surtido_code").val());
        formData.append('_method', 'PUT'); //requerido para enviar el archivo se tiene que usar post en ajax

        document.getElementById('div_message').innerHTML = "";
        $.ajax({
            data: formData,
            url: url,
            //type: 'PUT',
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {

                if (typeof response['status'] !== 'undefined') {
                    Swal.fire('Advertencia', response['message'], 'info')
                        .then(() => {
                            location.reload();
                        });
                } else {
                    Swal.fire('Actualizado', 'Se actualizo el usuario correctamente', 'success')
                        .then(() => {
                            $('#modal-users').modal("hide");
                            let url = window.location.origin + '/users/get';
                            $('#users_table').DataTable().ajax.url(url).load();
                        });
                }

            })
            .fail(function (jqXHR, textStatus) {
                //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                if (jqXHR['status'] == 422) {

                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });

    $(document).on('click', '#send_assign', function (event) {
        event.preventDefault();

        let userId = $("#user_id").val();
        let url = window.location.origin + '/permissions/users/' + userId + '/roles';
        let formData = new FormData();

        // Recoger los roles seleccionados
        $("input[name='roles[]']:checked").each(function() {
            formData.append('roles[]', $(this).val());
        });

        document.getElementById('div_message').innerHTML = "";

        $.ajax({
            data: formData,
            url: url,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(function (response) {
                Swal.fire('Actualizado', 'Roles actualizados correctamente', 'success')
                    .then(() => {
                        $('#modal-usersEntityHasRoles').modal("hide");
                        let url = window.location.origin + '/users/get';
                        $('#users_table').DataTable().ajax.url(url).load();
                    });
            })
            .fail(function (jqXHR, textStatus) {
                // Validación de Laravel a los campos
                if (jqXHR['status'] == 422) {
                    let errors = "<ul class=''>";
                    let items = "";

                    $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                        items = items + "<li class=''>" + value + "</li>";
                    });

                    errors = errors + items + "</ul>";
                    let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                        + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                        + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                        + errors
                        + "</div></div></div>";
                    document.getElementById('div_message').innerHTML = view;
                } else {
                    console.log(jqXHR['status']);
                    alert("Disculpe, existió un problema");
                }
            });
    });


}
